/**
 * Load ember app
 * @param {string} appName 
 * @param {string} appUrl 
 * @returns 
 */
export function loadEmberApp(appName, appUrl) {
    var vendorUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return new Promise(function(resolve, reject) {
        if (typeof appName !== 'string') {
            reject(new Error('single-spa-ember requires an appName string as the first argument'));
            return;
        }

        if (typeof appUrl !== 'string') {
            reject(new Error('single-spa-ember requires an appUrl string as the second argument'));
            return;
        }

        if (vendorUrl && typeof vendorUrl !== 'string') {
            reject(new Error('single-spa-ember vendorUrl (the third argument) is optional, but must be a string if present'));
            return;
        }

        if (vendorUrl) {
            var scriptVendor = document.createElement('script');
            scriptVendor.src = vendorUrl;
            scriptVendor.onload = loadApp;
            scriptVendor.onerror = reject;
            scriptVendor.setAttribute('crossorigin', 'anonymous');
            document.body.appendChild(scriptVendor);
        } else {
            loadApp();
        }
        /**
         * Load ember app
         */
        function loadApp() {
            var scriptEl = document.createElement('script');
            scriptEl.src = appUrl;
            scriptEl.onload = function() {
                resolve(window.require(appName + '/app'));
            };
            scriptEl.onerror = reject;
            scriptEl.setAttribute('crossorigin', 'anonymous');
            document.body.appendChild(scriptEl);
        }
    });
}